import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useTheme } from '@mui/material';

export const SignOut = () => {
  const theme = useTheme();

  return (
    <ExitToAppIcon
      fontSize="medium"
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
